const isIfDesignAward = (el) => el.awardType === 2;

export const getIfDesignAwardBadge = (el) => {
  if(el.awardType === 1) {
    if(el.status === 37){
      return null
    }
  }
  if (el.goldAward) {
    return 'ifDesignAwardGold';
  } else if (isIfDesignAward(el)) {
    return 'ifDesignAward';
  }
  return null;
};
